export function quizInit() {
    $('.main').css('min-height', $('window').height());

    $('#quiz-start').on('click', function() {
        $('.quiz.hidden').removeClass('hidden');
        $('.splash').fadeOut();
        $('nav.navbar').addClass('opaque');
        $('.main').css('height', $('.question.active').outerHeight());
    });

    $('.options .option').on('click', function() {
        $('.options .option').removeClass('selected');
        $(this).addClass('selected');

        $(this).parents('.question').find('a.btn.disabled').removeClass('disabled');
    });

    $('.question').fadeOut(0);
    $('.question.active').fadeIn();

    $('.btn.next').on('click', function() {
        let question = this;
        
        // Fade in next question
        $(question).parents('.question').fadeOut(function() {
            $(question).parents('.question').next().fadeIn();

            // Adjust height dynamically
            let nextQuestionHeight = $(question).parents('.question').next().outerHeight();
            $('.main').css('height', nextQuestionHeight);

            // Scroll to top (mostly for mobile)
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, 500, 'swing', function() {});
        });
    });

    $('.btn.results').on('click', function() {
        var inst = $('[data-remodal-id=modal]').remodal();
        inst.open();
    });
}